<div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6">
  <div class="max-w-md w-full">
    <!-- Logo -->
    <div class="flex justify-center mb-8">
      <img src="assets/img/Logo_sidemenu.png" alt="Logo" class="max-w-full h-auto max-h-20" />
    </div>

    <div class="bg-white rounded-2xl shadow-xl border border-gray-200 p-8">
      <!-- Header -->
      <div class="text-center mb-6">
        <h1 class="text-2xl font-bold text-gray-900 mb-2">Accès en attente</h1>
        <div class="w-16 h-1 bg-gradient-to-r from-[#993225] to-[#7C281E] mx-auto rounded-full"></div>
      </div>

      <!-- Message -->
      <div class="space-y-4 mb-8">
        <div class="bg-gradient-to-br from-yellow-50 to-orange-50 border border-yellow-200 rounded-xl p-4">
          <div class="flex items-start space-x-3">
            <div class="flex-shrink-0">
              <svg class="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"/>
              </svg>
            </div>
            <div>
              <h3 class="text-sm font-semibold text-yellow-800 mb-1">Votre compte est actif</h3>
              <p class="text-sm text-yellow-700 leading-relaxed">
                Aucun espace de travail ne vous est encore attribué. Un administrateur
                doit vous accorder un rôle — <strong>Finances</strong> pour la gestion
                locative, <strong>Gestionnaire</strong> pour l'espace gestionnaire.
              </p>
            </div>
          </div>
        </div>

        <!-- Identité du compte : ce que l'administrateur aura besoin de savoir -->
        <div class="rounded-xl border border-gray-200 bg-gray-50 p-4 space-y-2">
          @if (email()) {
            <div class="flex items-baseline justify-between gap-3">
              <span class="text-xs font-semibold uppercase tracking-wider text-gray-500">Compte</span>
              <span class="text-sm text-gray-900 break-all text-right">{{ email() }}</span>
            </div>
          }
          <div class="flex items-baseline justify-between gap-3">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-500">Rôles</span>
            <span class="text-sm text-gray-900 text-right">
              {{ groups().length ? groups().join(', ') : 'aucun' }}
            </span>
          </div>
        </div>

        <p class="text-sm text-gray-600 leading-relaxed">
          Si vous veniez d'une page précise, elle est réservée à un rôle que vous n'avez pas.
          Une fois le rôle attribué, déconnectez-vous puis reconnectez-vous pour qu'il prenne effet.
        </p>
      </div>

      <!-- Sign Out Button -->
      <div class="text-center">
        <button
          (click)="signOut()"
          class="w-full py-3 px-6 bg-gradient-to-r from-[#993225] to-[#7C281E] text-white font-semibold rounded-xl hover:shadow-lg hover:scale-105 transition-all duration-200 flex items-center justify-center space-x-2 group focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#993225]"
        >
          <svg class="w-5 h-5 transition-transform duration-200 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
          <span>Se déconnecter</span>
        </button>
      </div>

      <!-- Footer -->
      <div class="mt-6 text-center">
        <p class="text-xs text-gray-500">
          Besoin d'aide ? Contactez votre administrateur système
        </p>
      </div>
    </div>
  </div>
</div>
